<template>
  <user-card 
    title="Datos de la compra - Celular del vendedor y valor de tu compra"
    :color="this.configurations.data.header_color"
  >
    <v-row>
      <v-col 
        style="min-width: 200px; max-width: 320px;" 
        v-if="visible && !webcheckout"
      >
        <validation-provider
          name="Celular vendedor"
          rules="required|phone:10"
          v-slot="{ errors }"
        >
          <v-text-field
            ref="phone"
            :value="value.phone"
            @input="text => onTextChanged('phone', text)"
            v-mask="'### ### ####'"
            label="Celular vendedor"
            :error-messages="errors"
            :readonly="readonly"
            autofocus
          />
        </validation-provider>
      </v-col>
      <v-col
        :class="{ 'amount': !visible }" 
        v-show="!visible"
        ><h3 class="amount">{{amount}}</h3></v-col>
      <v-col 
        style="min-width: 200px; max-width: 310px"
        :class="{ 'amount': !visible,'webcheckout': true } "
        v-show="visible"
        >
        <validation-provider
          name="Valor"
          mode="lazy"
          :rules="`required|money: ${this.configurations.data.transaction_minimum_amount},${this.configurations.data.transaction_maximum_amount}`"
          v-slot="{ errors }"
        >
          <v-text-field
            ref="price"
            label="Valor"
            v-model.lazy="amount"
            name="card_amount"
            :max="7"  
            v-money="{
              decimal: ',',
              thousands: '.',
              prefix: '$ ',
              suffix: ' COP',
              precision: 0
            }"
            :readonly="readonly"
            :disabled="readonly"
            prepend-inner-icon="mdi-cash-usd-outline"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <template slot="footer">
      <slot name="footer" />
    </template>
  </user-card>
</template>
<script>
import UserCard from "./UserCard.vue";
import { mask } from "vue-the-mask";

export default {
  components: { UserCard },
  directives: { mask },
  props: {
    value: { type: Object, default: () => {} },
    readonly: { type: Boolean, default: false },
    webcheckout: { type: Boolean, default: false },
    visible: { type: Boolean, default: true },
    configurations: { type: Object, default: () => {} }
  },
  created() {
    this.amount = this.value.amount;
  },
  data() {
    return { amount: undefined };
  },
  mounted() {
    this.$refs.phone.$el.focus();
    this.$refs.price.$el.focus();
  },
  methods: {
    onTextChanged(field, text) {
      this.$emit("input", { ...this.value, [field]: text });
    },
    requestFocus() {
      this.$refs.phone.$el.focus();
      this.$refs.price.$el.focus();
    },
    setAmount(amount) {
      this.$refs.price.$el.getElementsByTagName("input")[0].value = amount;
      this.amount = amount;
    }
  },
  watch: {
    amount(val) {
      if (val === undefined) this.emitInput("amount", undefined);
      else {
        this.onTextChanged(
          "amount",
          val
            .split("")
            .filter(val => val <= "9" && val >= "0")
            .join("")
        );
      }
    }
  }
};
</script>

<style scoped lang="sass">
.web_checkout
  margin: auto !important
  font-size: 3em !important
  max-width: 40% !important
.amount
  align: center
  font-size: 2em !important
  margin: auto !important
  text-align: center
.webcheckout
  align: center
  font-size: 1em !important
  margin: auto !important
  text-align: center

@media (max-width: 108px) 
  .amount
    font-size: 1.2em !important

@media (max-width: 450px) 
  .amount
    font-size: 1.4em !important

@media (min-width: 800px) 
  .amount
    font-size: 2em !important

</style>
